import React from "react";

/**
 * StayFlow logo — uses the official red "Flow" mark as a rounded app-icon
 * badge, paired with the StayFlow wordmark.
 */
export const Logo = ({ variant = "dark", withWordmark = true, className = "", markSize = 36 }) => {
  const wordColor = variant === "light" ? "#FFFFFF" : "#141414";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} aria-label="StayFlow">
      <img
        src="/stayflow-logo.png"
        alt="StayFlow logo"
        width={markSize}
        height={markSize}
        className="rounded-[9px] object-cover shadow-[0_6px_18px_rgba(255,26,26,0.35)]"
        style={{ width: markSize, height: markSize }}
      />
      {withWordmark && (
        <span
          className="font-heading text-[1.35rem] font-extrabold tracking-tight leading-none"
          style={{ color: wordColor }}
        >
          StayFlow
        </span>
      )}
    </div>
  );
};

export default Logo;
